/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 用户详细信息
 */
"use strict";
angular.module("userDetailsModule", []).
controller("userDetailsCtrl", ["$scope", "$modalInstance",'httpService','userId', function($scope, $modalInstance,httpService,userId) {
    initStatus();
	initData();
    function initStatus() {
    	
    };
    
    function initData() {
        requestData();

    };
    
    $scope.confirm = function() {
        $modalInstance.close($scope.abc);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    function requestData() {
    	var params = {
    		userId : userId
    	};
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/ugcuser/findById.do", params, "post").then(function(data) {
        	var info = data.data;
        	$scope.userinfo = {
		    	userName:info.userName,
		    	realName:info.truename || "未填写",
		    	sex:info.sex,
		    	tel:info.mobile || "未填写",
		    	email:info.email || "未填写",
		    	workAddress:info.unit || "未填写",
		    	address:info.address || "未填写"
		    };
            
        });
    };
}]);
